import type { ReactNode } from 'react'
import { Navigate } from '@tanstack/react-router'
import { useAuth } from '../auth/AuthContext.tsx'
import type { Role } from '../zero/auth.ts'
import { AccessDeniedPage } from './AccessDeniedPage.tsx'

/** Landing route: send each role to its home screen. */
export function IndexRedirect() {
  const { status, session } = useAuth()
  if (status === 'loading') return null
  if (!session) return <Navigate to="/login" />
  if (session.auth.role === 'kiosk') return <Navigate to="/order" />
  if (session.auth.role === 'admin') return <Navigate to="/admin" />
  return <Navigate to="/me" />
}

/** Wrap a page to require a session, optionally restricted to certain roles. */
export function Require({
  roles,
  children,
  showDenied = false,
}: {
  roles?: Role[]
  children: ReactNode
  showDenied?: boolean
}) {
  const { status, session } = useAuth()
  if (status === 'loading') return null
  if (!session) return <Navigate to="/login" />
  if (roles && !roles.includes(session.auth.role)) {
    return showDenied ? <AccessDeniedPage /> : <Navigate to="/" />
  }
  return <>{children}</>
}
